import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import Countact from './ContactUs'

export default function index() {
  return (
    <div>
        <Header/>
        <Countact/>
        <Footer/>
    </div>
  )
}
